import { Component, OnInit, Input } from '@angular/core';
import { NotaDebito } from '../../../models/nota-debito';
import { NotaDebitoService } from '../../../services/nota-debito.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-notadebito-modal',
  templateUrl: './notadebito-modal.component.html',
  styleUrls: ['./notadebito-modal.component.css'],
  providers: [NotaDebitoService]
})
export class NotadebitoModalComponent implements OnInit {
  @Input() nota_debito_id: String;
  public nota: NotaDebito;
  public loading = false;

  constructor(
      private notaService: NotaDebitoService,
      public bsModalRef: BsModalRef,
  ){
      this.nota = new NotaDebito();
  }

  ngOnInit(){
      this.getNotaDebitoById();
  }

  getSubtotal(subtotal_iva12, subtotal_iva0){
    return parseFloat(subtotal_iva12) + parseFloat(subtotal_iva0);
  }

  getNotaDebitoById(){
      this.loading = true;
      let qs = '?embed=tipocomprobante,caja,estadobitacora,venta?embed=bodega;cliente,detalle?embed=producto';
      this.notaService.getById(this.nota_debito_id, qs).subscribe(
          res => {
              this.loading = false;
              this.nota = res.data;
          },
          err => {
              this.loading = false;
          }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/notadebito-modal/notadebito-modal.component.ts